import React, {createRef, ReactElement} from 'react';
import {$KTS, Action, KeyTextStrings, ProvisionedAppConfig} from "../shared/types";
import "../res/css/App.css";
import {PathComponent} from "../index";
import {PeppinApp, PeppinMain} from "../peppin-shared/PeppinApp";
import {MainFragment} from "./MainFragment";
import {CasinoOutlined, DownloadOutlined} from "@mui/icons-material";
import {PARTS} from "./types";
import html2canvas from "html2canvas";

enum DownloadImageType {
  PNG = "png",
  SVG = "svg",
}

const DOWNLOAD_IMAGE_TYPE_KTS = new KeyTextStrings([
  $KTS(DownloadImageType.PNG, "PNG Image"),
  $KTS(DownloadImageType.SVG, "SVG Image"),
]);

class Main extends PeppinMain {

  private readonly mainFragment = createRef<MainFragment>();

  private onRandom() {
    const ids = new Map<string, string>();
    PARTS.forEach(part => ids.set(part.id, "" + Math.floor(Math.random() * part.count)));
    ids.set("accessories", "0");
    ids.set("details", "0");
    ids.set("beard", "0");
    this.mainFragment.current.setSelectedToolOptionIds(ids);
  }

  private onDownload() {
    App.CONTEXT.showActionsDialog("Download", Object.getOwnPropertyNames(DownloadImageType).map(name => {
      const type = DownloadImageType[name];
      return new Action(DOWNLOAD_IMAGE_TYPE_KTS.findText(type), () => this.onDownloadImage(type));
    }));
  }

  private async onDownloadImage(type: DownloadImageType) {
    const dom: HTMLElement = document.querySelector(
      '#avatar-preview',
    ) as HTMLElement;

    const canvas = await html2canvas(dom, {
      logging: false,
      scale: window.devicePixelRatio,
      width: dom.offsetWidth,
      height: dom.offsetHeight,
      backgroundColor: null,
    });
    // base64 only support png svg for now, maybe more change it to Map
    let imageURL;
    if (type === DownloadImageType.PNG) {
      imageURL = canvas.toDataURL();
    } else {
      const svgElement = dom.querySelector('svg');
      if (!svgElement) {
        // not generate for some reason
        return;
      }
      const svg = new XMLSerializer().serializeToString(svgElement);
      imageURL = `data:image/svg+xml;base64,${window.btoa(svg)}`;
    }

    const a = document.createElement('a');

    a.href = imageURL;
    a.download = `peppin-avatar-maker-${new Date().getTime()}.${type}`;
    a.click();
  }

  protected createToolbarActions(): Action[] {
    return [
      new Action("Random", () => this.onRandom(), CasinoOutlined),
      new Action("Download", (event) => this.onDownload(), DownloadOutlined).setVariant("contained").makeDropdown(),
    ]
  }

  renderContent(): React.ReactElement {
    return <MainFragment ref={this.mainFragment} path={this.props.path}/>;
  }
}

export class App extends PeppinApp {

  protected getAppName(): string {
    return "Avatar Maker";
  }

  getProvisionedAppId(): string {
    return "avatarmaker";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  static nestedPaths(): PathComponent[] {
    return [];
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
